import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { getAllLocation } from "../../../actions/warehouseAction";
// import { getAllOutlet } from "../../../actions/warehouseAction";
import { getAllChartofaccounts, getAllChartofaccountsByFilter } from "../../../actions/chartofaccountsAction";
import { resetAllChartofaccounts } from "../../../actions/chartofaccountsAction";
import { getJournalSearchResult } from "../../../actions/journalAction";
import moment from "moment"

// import Excelldownload from "./Excelldownload";
import dateFormat from "dateformat";
import AdcanceQuickview from "./advanceQuickview"
import * as XLSX from 'xlsx';

import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  DatePicker,
  TimePicker,
  Space,
  Select,
  Divider,
  Skeleton,
  Card,
  Button,
} from "antd";
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const Trailbalance = ({ getAllChartofaccounts, getJournalSearchResult, resetAllChartofaccounts, Auth, getAllLocation, getAllChartofaccountsByFilter }) => {
  const componentRef = useRef();
  const [charts, setcharts] = useState([]);
  const [journals, setjournals] = useState([]);
  const [locationList, setlocationList] = useState([]);
  //   const [outletlist, setoutletlist] = useState([]);
  const [type, setType] = useState("date");
  const [loading, setloading] = useState(true);
  const [reload, setreload] = useState(false);
  const start = useRef("");
  const end = useRef("");
  const location = useRef(Auth.profile.branch.id)
  const totaldebit = useRef(0);
  const totalcredit = useRef(0);
  const totaldebit_change = useRef(0);
  const totalcredit_change = useRef(0);
  const totaldebit_previous = useRef(0);
  const totalcredit_previous = useRef(0);
  const sl = useRef(0);
  //   const location = useRef("");
  var formatter = new Intl.NumberFormat("en-IN");

  useEffect(() => {
    // alert("Trail Balance is updated. Please check the latest version.");
    setloading(true);

    resetAllChartofaccounts().then((done) => {
      getAllLocation().then(locations => {
        setlocationList(locations);
        if ((start.current != "" && end.current != "")) {
          getAllChartofaccountsByFilter(
            start.current,
            end.current,
            // location.current
          ).then((result) => {
            totaldebit.current = 0;
            totalcredit.current = 0;
            totaldebit_change.current = 0;
            totalcredit_change.current = 0;
            totaldebit_previous.current = 0;
            totalcredit_previous.current = 0;
            setcharts(result);
            setloading(false);
          });
        } else {
          setloading(false);
        }
      })
    });
  }, [reload]);



  const accountRender = (chart) => {
    if (loading) {

      return <Skeleton active />;
    } else {
      if (chart.status == "Debit") {
        totaldebit.current += Math.abs(chart.amount);
      } else {
        totalcredit.current += Math.abs(chart.amount);
      }

      
      totaldebit_change.current += Math.abs(chart.current_debit);
      totalcredit_change.current += Math.abs(chart.current_credit);

      totaldebit_previous.current += Math.abs(chart.previous_debit);
      totalcredit_previous.current += Math.abs(chart.previous_credit);
      if (Math.abs(chart.amount) > 0 || Math.abs(chart.previous_amount) > 0 || Math.abs(chart.current_amount) > 0) {
        return (
          <>
            <tr>
              <td>
                <AdcanceQuickview
                  details={chart}
                  start={start}
                  end={end}
                  location={location}
                />
                {chart.current_amount > 0 ? " +" : chart.current_amount < 0 ? " -" : ""}</td>
              <td style={{ textAlign: "right", backgroundColor: "#f2f2f2" }}>
                {chart.previous_status == "Debit"
                  ? <>{Math.abs(chart.previous_amount) != 0 && formatter.format(
                    parseFloat(Math.abs(chart.previous_amount)).toFixed(2)
                  )}</>
                  : ""}
              </td>
              <td style={{ textAlign: "right", backgroundColor: "#f2f2f2" }}>
                {chart.previous_status == "Credit"
                  ? <>{Math.abs(chart.previous_amount) != 0 && formatter.format(
                    parseFloat(Math.abs(chart.previous_amount)).toFixed(2)
                  )}</>
                  : ""}
              </td>
              <td style={{ textAlign: "right", backgroundColor: "#eeeeeeff" }}>
                {/* {chart.current_status == "Debit"
                  ? <> {Math.abs(chart.current_amount) != 0 && formatter.format(
                    parseFloat(Math.abs(chart.current_amount)).toFixed(2)
                  )}</>
                  : ""} */}
                  {Math.abs(chart.current_debit) != 0 && formatter.format(
                    parseFloat(Math.abs(chart.current_debit)).toFixed(2)
                  )}
              </td>
              <td style={{ textAlign: "right", backgroundColor: "#eeeeeeff" }}>
                {/* {chart.current_status == "Credit"
                  ? <> {Math.abs(chart.current_amount) != 0 && formatter.format(
                    parseFloat(Math.abs(chart.current_amount)).toFixed(2)
                  )}</>
                  : ""} */}
                  {Math.abs(chart.current_credit) != 0 && formatter.format(
                    parseFloat(Math.abs(chart.current_credit)).toFixed(2)
                  )}
              </td>
              <td style={{ textAlign: "right", backgroundColor: "#e8e8e8ff" }}>
                {chart.status == "Debit"
                  ? formatter.format(
                    parseFloat(Math.abs(chart.amount)).toFixed(2)
                  )
                  : ""}
              </td>
              <td style={{ textAlign: "right", backgroundColor: "#e8e8e8ff" }}>
                {chart.status == "Credit"
                  ? formatter.format(
                    parseFloat(Math.abs(chart.amount)).toFixed(2)
                  )
                  : ""}
              </td>
            </tr>
          </>
        );
      }
    }
  };


// Method 1: Download as HTML file (opens in Excel with full colors and formatting)
const downloadExcelWithColors = () => {
  // Helper function to format numbers
  const formatNumber = (num) => {
    const formatter = new Intl.NumberFormat("en-IN");
    return num != 0 ? formatter.format(parseFloat(Math.abs(num)).toFixed(2)) : '';
  };

  // Build HTML content with inline styles for colors
  let htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
        <meta charset="utf-8">
        <title>Trial Balance</title>
        <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { border-collapse: collapse; width: 100%; margin-top: 20px; }
            th, td { border: 1px solid #000; padding: 8px; text-align: left; }
            .header { background-color: #70AD47; color: white; font-weight: bold; text-align: center; font-size: 18px; }
            .title { background-color: #4472C4; color: white; font-weight: bold; text-align: center; font-size: 16px; }
            .date-range { background-color: #D9D9D9; text-align: center; font-weight: bold; }
            .column-header { background-color: #4472C4; color: white; font-weight: bold; text-align: center; }
            .sub-header { background-color: #B4C6E7; color: #000; font-weight: bold; text-align: center; }
            .section-header { background-color: #A5A5A5; color: white; font-weight: bold; }
            .totals { background-color: #70AD47; color: white; font-weight: bold; }
            .number { text-align: right; }
            .opening { background-color: #F2F2F2; }
            .change { background-color: #EEEEEE; }
            .balance { background-color: #E8E8E8; }
        </style>
    </head>
    <body>
        <table>
  `;

  // Add company header

  htmlContent += `
            
            <tr>
                <td colspan="7" class="title">Trial Balance</td>
            </tr>
  `;

  // Add date range if available
  if (start.current && end.current) {
    const dateRange = `From ${dateFormat(start.current, "mmmm dS, yyyy")} To ${dateFormat(end.current, "mmmm dS, yyyy")}`;
    htmlContent += `
            <tr>
                <td colspan="7" class="date-range">${dateRange}</td>
            </tr>
    `;
  }

  // Add column headers
  htmlContent += `
            <tr>
                <td rowspan="2" class="column-header">Particulars</td>
                <td colspan="2" class="column-header">Opening</td>
                <td colspan="2" class="column-header">Change</td>
                <td colspan="2" class="column-header">Balance</td>
            </tr>
            <tr>
                <td class="sub-header">Debit</td>
                <td class="sub-header">Credit</td>
                <td class="sub-header">Debit</td>
                <td class="sub-header">Credit</td>
                <td class="sub-header">Debit</td>
                <td class="sub-header">Credit</td>
            </tr>
  `;

  // Reset totals
  let tempTotalDebit = 0;
  let tempTotalCredit = 0;
  let tempTotalDebitChange = 0;
  let tempTotalCreditChange = 0;
  let tempTotalDebitPrevious = 0;
  let tempTotalCreditPrevious = 0;

  // Function to add section data
  const addSectionToHTML = (sectionName, filterCondition) => {
    htmlContent += `
            <tr>
                <td class="section-header"><strong>${sectionName}</strong></td>
                <td class="section-header" colspan="6"></td>
            </tr>
    `;

    charts.forEach(chart => {
      if (filterCondition(chart)) {
        if (Math.abs(chart.amount) > 0 || Math.abs(chart.previous_amount) > 0 || Math.abs(chart.current_amount) > 0) {
          // Update totals
          if (chart.status === "Debit") {
            tempTotalDebit += Math.abs(chart.amount);
          } else {
            tempTotalCredit += Math.abs(chart.amount);
          }
          
          tempTotalDebitChange += Math.abs(chart.current_debit);
          tempTotalCreditChange += Math.abs(chart.current_credit);
          tempTotalDebitPrevious += Math.abs(chart.previous_debit);
          tempTotalCreditPrevious += Math.abs(chart.previous_credit);

          const accountName = chart.account_name || chart.name;
          const changeIndicator = chart.current_amount > 0 ? " +" : chart.current_amount < 0 ? " -" : "";
          
          htmlContent += `
            <tr>
                <td>${accountName}${changeIndicator}</td>
                <td class="number opening">${chart.previous_status === "Debit" ? formatNumber(chart.previous_amount) : ''}</td>
                <td class="number opening">${chart.previous_status === "Credit" ? formatNumber(chart.previous_amount) : ''}</td>
                <td class="number change">${formatNumber(chart.current_debit)}</td>
                <td class="number change">${formatNumber(chart.current_credit)}</td>
                <td class="number balance">${chart.status === "Debit" ? formatNumber(chart.amount) : ''}</td>
                <td class="number balance">${chart.status === "Credit" ? formatNumber(chart.amount) : ''}</td>
            </tr>
          `;
        }
      }
    });
  };

  // Add each section
  addSectionToHTML('Assets', (chart) => 
    chart.account_code > 10000 && chart.Group[0].account_name === "Assets"
  );
  
  addSectionToHTML('Liabilities', (chart) => 
    chart.account_code > 10000 && chart.Group[0].account_name === "Liabilities"
  );
  
  addSectionToHTML('Expenses', (chart) => 
    chart.account_code > 10000 && chart.Group[0].account_name === "Expense"
  );
  
  addSectionToHTML('Revenue', (chart) => 
    chart.account_code > 10000 && chart.Group[0].account_name === "Revenue"
  );
  
  addSectionToHTML("Owner's Equity", (chart) => 
    chart.account_code > 10000 && chart.Group[0].account_name === "Owner's equity"
  );

  // Add totals row
  const formatter = new Intl.NumberFormat("en-IN");
  htmlContent += `
            <tr>
                <td class="totals"><strong>Total</strong></td>
                <td class="totals number">${formatter.format(parseFloat(tempTotalDebitPrevious).toFixed(2))}</td>
                <td class="totals number">${formatter.format(parseFloat(tempTotalCreditPrevious).toFixed(2))}</td>
                <td class="totals number">${formatter.format(parseFloat(tempTotalDebitChange).toFixed(2))}</td>
                <td class="totals number">${formatter.format(parseFloat(tempTotalCreditChange).toFixed(2))}</td>
                <td class="totals number">${formatter.format(parseFloat(tempTotalDebit).toFixed(2))}</td>
                <td class="totals number">${formatter.format(parseFloat(tempTotalCredit).toFixed(2))}</td>
            </tr>
  `;

  // Close HTML
  htmlContent += `
        </table>
    </body>
    </html>
  `;

  // Create and download the file
  const blob = new Blob([htmlContent], { type: 'application/vnd.ms-excel' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    
    const startDate = start.current ? dateFormat(start.current, "yyyy-mm-dd") : 'no-date';
    const endDate = end.current ? dateFormat(end.current, "yyyy-mm-dd") : 'no-date';
    link.setAttribute('download', `trial_balance_${startDate}_to_${endDate}.xls`);
    
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};


  const SwitchablePicker = () => {
    return (
      <Row>
        <Col span={12}>
          <Space>
            Select a date range to generate the report :
            <RangePicker
              picker={type}
              onChange={(value) => {
                if (value) {
                  start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                  end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                  totaldebit.current = 0;
                  totalcredit.current = 0;
                  totaldebit_change.current = 0;
                  totalcredit_change.current = 0;
                  totaldebit_previous.current = 0;
                  totalcredit_previous.current = 0;
                }
              }}
            />
            {/* Location :
            <Select
              style={{ minWidth: "200px" }}
              onChange={(value) => {
                location.current = value;
              }}
              defaultValue={Auth.profile.branch.id}
            >
              <Option value="-99">All</Option>
              {locationList.map((item) => {
                return (
                  <Option value={item.id}>{item.name}</Option>
                );
              })}
            </Select> */}

            <Button onClick={() => setreload(!reload)} type="primary">Search</Button>
          </Space>
        </Col>

        <Col span={12}>
        <Space style={{ float: 'right' }}>
          <Button 
            onClick={downloadExcelWithColors} 
            type="default"
            disabled={charts.length === 0 || loading}
            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: 'white' }}
          >
            Download Excel 
          </Button>
          
          <ReactToPrint
            trigger={() => <Button type="primary">Print Trial Balance</Button>}
            content={() => componentRef.current}
          />
        </Space>
      </Col>
      </Row>
    );
  };

  const Rendercontent = () => {
    if (loading) {
      return (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      );
    } else {
      totaldebit.current = 0
      totalcredit.current = 0
      return (
        <>
          <Row>
            <Col
              span={24}
              style={{
                padding: "1rem",
                border: "1px solid whitesmoke",
              }}
            >

              {/* <RenderTable List={data} /> */}
              <div ref={componentRef} style={{ padding: "20px" }}>
                <table className="account_table">
                  <tr
                    style={{
                      textAlign: "center",
                      backgroundColor: "#99FE8E",
                      minHeight: "50px",
                    }}
                  >
                    <td colSpan={7}>
                      <b>
                        
                        <h3>Trial Balance</h3>
                        {start.current != "" ? (
                          <h3>
                            From {dateFormat(start.current, "mmmm dS, yyyy")}{" "}
                            {"  "}To{"  "}
                            {dateFormat(end.current, "mmmm dS, yyyy")}
                          </h3>
                        ) : (
                          ""
                        )}
                      </b>
                    </td>
                  </tr>
                  <tr
                    style={{
                      textAlign: "center",
                      // backgroundColor: "#99FE8E",
                      height: "50px",
                    }}
                  >
                    <td rowSpan={2}>
                      <b>Particulars</b>
                    </td>
                    <td colSpan={2} style={{ textAlign: "center", backgroundColor: "#eeeeeeff" }}>
                      <b>Opening</b>
                    </td>
                    <td colSpan={2} style={{ textAlign: "center", backgroundColor: "#eeeeeeff" }}>
                      <b>Change</b>
                    </td>
                    <td colSpan={2} style={{ textAlign: "center", backgroundColor: "#e8e8e8ff" }}>
                      <b>Balance</b>
                    </td>


                  </tr>
                  <tr
                    style={{
                      textAlign: "center",
                      // backgroundColor: "#99FE8E",
                      height: "50px",
                    }}
                  >
                    {/* <td>
                      <b>Particulars</b>
                    </td> */}
                    <td style={{ textAlign: "center", backgroundColor: "#eeeeeeff" }}>
                      <b>Debit</b>
                    </td>
                    <td style={{ textAlign: "center", backgroundColor: "#eeeeeeff" }}>
                      <b>Credit</b>
                    </td>
                    <td style={{ textAlign: "center", backgroundColor: "#eeeeeeff" }}>
                      <b>Debit</b>
                    </td>
                    <td style={{ textAlign: "center", backgroundColor: "#eeeeeeff" }}>
                      <b>Credit</b>
                    </td>
                    <td style={{ textAlign: "center", backgroundColor: "#e8e8e8ff" }}>
                      <b>Debit</b>
                    </td>
                    <td style={{ textAlign: "center", backgroundColor: "#e8e8e8ff" }}>
                      <b>Credit</b>
                    </td>
                  </tr>

                  <tr style={{ background: "lightgray" }}>
                    <td>
                      <b>Assets</b>
                    </td>
                    <td colSpan={6}></td>

                  </tr>
                  {charts.map((chart) => {
                    if (
                      chart.account_code > 10000 &&
                      "Assets" == chart.Group[0].account_name
                    ) {
                      return accountRender(chart);
                    }
                  })}
                  <tr style={{ background: "lightgray" }}>
                    <td>
                      <b>Liabilities</b>
                    </td>
                    <td colSpan={6}></td>
                  </tr>
                  {charts.map((chart) => {
                    if (
                      chart.account_code > 10000 &&
                      "Liabilities" == chart.Group[0].account_name
                    ) {
                      return accountRender(chart);
                    }
                  })}
                  <tr style={{ background: "lightgray" }}>
                    <td>
                      <b>Expenses</b>
                    </td>
                    <td colSpan={6}></td>
                  </tr>
                  {charts.map((chart) => {
                    if (
                      chart.account_code > 10000 &&
                      "Expense" == chart.Group[0].account_name
                    ) {
                      return accountRender(chart);
                    }
                  })}
                  <tr style={{ background: "lightgray" }}>
                    <td>
                      <b>Revenue </b>
                    </td>
                    <td colSpan={6}></td>
                  </tr>
                  {charts.map((chart) => {
                    if (
                      chart.account_code > 10000 &&
                      "Revenue" == chart.Group[0].account_name
                    ) {
                      return accountRender(chart);
                    }
                  })}
                  <tr style={{ background: "lightgray" }}>
                    <td>
                      <b>Owner's equity </b>
                    </td>
                    <td colSpan={6}></td>
                  </tr>
                  {charts.map((chart) => {
                    if (
                      chart.account_code > 10000 &&
                      "Owner's equity" == chart.Group[0].account_name
                    ) {
                      return accountRender(chart);
                    }
                  })}
                  <tr
                    style={{
                      textAlign: "center",
                      height: "40px",
                    }}
                  >
                    <td colSpan={1}>
                      <b>Total</b>
                    </td>
                    <td style={{
                        textAlign: "right",
                      }}>{formatter.format(parseFloat(totaldebit_previous.current).toFixed(2))}</td>
                    <td style={{
                        textAlign: "right",
                      }}>{formatter.format(parseFloat(totalcredit_previous.current).toFixed(2))}</td>
                    <td style={{
                        textAlign: "right",
                      }}>{formatter.format(parseFloat(totaldebit_change.current).toFixed(2))}</td>
                    <td style={{
                        textAlign: "right",
                      }}>{formatter.format(parseFloat(totalcredit_change.current).toFixed(2))}</td>
                    <td
                      style={{
                        backgroundColor: "#99FE8E",
                        textAlign: "right",
                      }}
                    >
                      <b>
                        {formatter.format(
                          parseFloat(totaldebit.current).toFixed(2)
                        )}
                      </b>
                    </td>
                    <td
                      style={{
                        backgroundColor: "#99FE8E",
                        textAlign: "right",
                      }}
                    >
                      <b>
                        {formatter.format(
                          parseFloat(totalcredit.current).toFixed(2)
                        )}
                      </b>
                    </td>
                  </tr>
                </table>
              </div>
            </Col>
          </Row>
        </>
      );
    }
  };
  return (
    <>

            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Trial balance</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
              {SwitchablePicker()}
              <Divider />
              {Rendercontent()}
            </div>
          
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, { getAllChartofaccounts, getJournalSearchResult, resetAllChartofaccounts, getAllLocation, getAllChartofaccountsByFilter })(
  Trailbalance
);
